import fetchUsers from './getUsers';
import watchLockUser from './lockUser';

const watchGetTelephonyUsers = [fetchUsers, watchLockUser];

export default watchGetTelephonyUsers;
